import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import en from "./translations/en.json";
import de from "./translations/de.json";
import fr from "./translations/fr.json";
import nl from "./translations/nl.json";
import { createI18n } from "vue-i18n";
import axios from "axios";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import RequiredMark from "./components/RequiredMark";
import LoaderAnimation from "./components/LoaderAnimation.vue";

const i18n = createI18n({
    // legacy: true,
    locale: "en",
    messages: {
        en,
        de,
        nl,
        fr
    },
    fallbackLocale: "en"
});

const swalOptions = {
    confirmButtonColor: "#00b8d3",
    cancelButtonColor: "#ff7674"
};

// Only mount the Vue app if the #app element exists
// This allows server-rendered pages (like Stripe success/cancel) to work without Vue
// record the furthest step reached on the draft booking (abandonment tracking);
// fire-and-forget, the wizard never waits on it
store.subscribe((mutation, state) => {
    if (
        mutation.type === "CHANGE_PROGRESS_STEP" &&
        state.bookingDetails.bookingId
    ) {
        axios
            .post(process.env.VUE_APP_ROOT_URL + "booking/progress", {
                bid: state.bookingDetails.bookingId,
                step: mutation.payload
            })
            .catch(() => {});
    }
});

if (document.getElementById("app")) {
    const app = createApp(App);
    // app.component(RequiredMark);
    app.component("RequiredMark", RequiredMark);
    app.component("LoaderAnimation", LoaderAnimation);
    app.use(store);
    app.use(router);
    app.use(i18n);
    app.use(VueSweetalert2, swalOptions);
    app.mount("#app");
}
